import axios from 'axios'
import i18n, { getLanguage } from '@/i18n'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '',
  timeout: 30000
})

service.interceptors.request.use(
  config => {
    config.headers['Accept-Language'] = getLanguage() === 'en' ? 'en' : 'zh-CN'
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => {
    // 二进制响应（blob 下载）直接返回
    if (response.config.responseType === 'blob' || response.config.responseType === 'arraybuffer') {
      return response.data
    }
    const res = response.data
    if (res.code === 200) {
      return res
    }
    return Promise.reject(new Error(res.msg || i18n.t('common.hint.requestFailed')))
  },
  error => {
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

export default service
